import { jsx as r } from "react/jsx-runtime";
function i(e) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 14 15",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--fill-primary))",
      fill: "rgb(var(--background-secondary))",
      ...e,
      children: /* @__PURE__ */ r(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9242 1.00738H9.4459L9.17343 0.465349C9.0557 0.228979 8.8143 0.0796491 8.55024 0.0798391H5.23717C4.9736 0.0788291 4.73266 0.228569 4.61687 0.465349L4.3444 1.00738H0.866114C0.609984 1.00738 0.402344 1.21502 0.402344 1.47115V2.39869C0.402344 2.65482 0.609984 2.86246 0.866114 2.86246H12.9242C13.1803 2.86246 13.388 2.65482 13.388 2.39869V1.47115C13.388 1.21502 13.1803 1.00738 12.9242 1.00738H12.9242ZM1.94439 13.6162C1.9903 14.3493 2.59824 14.9204 3.33281 14.9205H10.4575C11.1919 14.9205 11.7999 14.3495 11.8459 13.6163L12.4604 3.79H1.32989L1.94439 13.6162Z"
        }
      )
    }
  );
}
export {
  i as TrashIcon
};
